import {
  UPDATE_SERVICE,
  UPDATE_SERVICE_FAILURE,
  UPDATE_SERVICE_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const updateServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SERVICE:
      return { ...state, loading: true };
    case UPDATE_SERVICE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case UPDATE_SERVICE_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default updateServiceReducer;
